function obterHoraFormatada() {
  const dataAtual = new Date();

  // Obtém a hora e os minutos
  const horas = adicionarZero(dataAtual.getHours());
  const minutos = adicionarZero(dataAtual.getMinutes());

  // Formata a hora no formato hh/mm
  const horaFormatada = `${horas}:${minutos}`;

  return horaFormatada;
}

function obterDataFormatada(saidaArquivo) {
  const dataAtual = new Date();

  // Obtém o dia, o mês e o ano
  const dia = adicionarZero(dataAtual.getDate());
  const mes = adicionarZero(dataAtual.getMonth() + 1); // Os meses começam do zero
  const ano = dataAtual.getFullYear();

  // Formata a data no formato dd/mm/aaaa
  const dataFormatada = saidaArquivo
    ? `${dia}-${mes}-${ano}`
    : `${dia}/${mes}/${ano}`;

  return dataFormatada;
}

function adicionarZero(numero) {
  // Adiciona um zero à esquerda se o número for menor que 10
  return numero < 10 ? `0${numero}` : numero;
}

   function formatarData(data) {
     const partes = data.split(/[ T.]/);

     // Partes[0] contém a parte da data "aaaa-mm-dd"
     const [ano, mes, dia] = partes[0].split("-");

     // Formata a data no formato "dd/mm/aaaa"
     const dataFormatada = `${dia}/${mes}/${ano}`;

     return dataFormatada;
   }



   function formatCNPJ(input) {
     // Remove qualquer caractere que não seja número
     let value = input.replace(/\D/g, "");

     // Adiciona a máscara
     value = value.replace(/^(\d{2})(\d)/, "$1.$2");
     value = value.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
     value = value.replace(/\.(\d{3})(\d)/, ".$1/$2");
     value = value.replace(/(\d{4})(\d)/, "$1-$2");

     // Atualiza o valor do input
     return value;
   }


export { obterDataFormatada, obterHoraFormatada, formatarData, formatCNPJ };